import {
    SchedulesActionTypes, AddSchedules, ModifySchedules, DeleteSchedules
} from './ActionTypes';
import { Schedule, Id } from 'NSwag/ServerClient/Client.nswag';

export const addSchedules = (schedules: Schedule[]): AddSchedules => ({
    type: SchedulesActionTypes.Add as SchedulesActionTypes.Add,
    schedules
});

export const modifySchedules = (schedules: Schedule[]): ModifySchedules => ({
    type: SchedulesActionTypes.Modify as SchedulesActionTypes.Modify,
    schedules
});

export const deleteSchedules = (ids: Id[]): DeleteSchedules => ({
    type: SchedulesActionTypes.Delete as SchedulesActionTypes.Delete,
    ids
});

export type SchedulesAction = ReturnType<typeof addSchedules | typeof modifySchedules | typeof deleteSchedules >